import { Injectable } from '@angular/core';
import { 
  CanActivate, 
  ActivatedRouteSnapshot, 
  RouterStateSnapshot, 
  Router 
} from '@angular/router';
import { PermissionsService } from '../service/permissions.service';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { AlertService } from '@rslweb/shared/common'

@Injectable({
  providedIn: 'root'
})
export class PermissionsGuard implements CanActivate {
  constructor(
    private permissionsService: PermissionsService,
    private router: Router,
    private alertService: AlertService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const requiredPermission = route.data['requiredPermission'];
    if (!requiredPermission) {
      console.warn('No permission specified for route:', route.url);
      return of(true);
    }

    return this.permissionsService.loadUserPermissions().pipe(
      take(1),
      map(() => {
        const hasPermission = this.permissionsService.hasPermission(requiredPermission);
        if (!hasPermission) {
          console.warn(`Access denied: Missing required permission: ${requiredPermission}`);
          this.alertService.error('Access denied: Missing required permission');
          return false;
        }
        return true;
      }),
      catchError(error => {
        console.error('Permission check failed:', error);
        this.router.navigate(['/auth/login']);
        return of(false);
      })
    );
  }
}